import { render, staticRenderFns } from "./BoxBorder.vue?vue&type=template&id=ec458580&"
import script from "./BoxBorder.vue?vue&type=script&lang=js&"
export * from "./BoxBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports